import React, { Component } from "react";
import { MDBRow, MDBCol, MDBContainer, MDBCard, MDBCardBody, MDBCardText } from "mdbreact";
// import picc1 from "../assets/calendar/procedure.jpg";
// import imgKantorn from "../assets/2025/1.png";
import imgKantorn from "../assets/2026/preduc/pre.png";
import MetaTags from "react-meta-tags";
import { Image, Pane } from "evergreen-ui";

export default class Procedureregister extends Component {
  constructor(props) {
    super(props);
    this.state = {
      screenWidth: 0,
      screenHieght: 0,
    };
  }

  componentDidMount() {
    if (window.screen.width < 500) {
      this.setState({ screenWidth: "100%" });
    } else {
      this.setState({ screenWidth: window.screen.width * 0.3 });
    }
    this.setState({ screenHieght: window.screen.height });
  }
  render() {
    return (
      <>
        <MetaTags>
          <title>ขั้นตอนการสมัครของระบบรับสมัครมหาวิทยาลัยราชภัฏกำแพงเพชร</title>
          <meta
            name="description"
            content="ขั้นตอนการสมัครของระบบรับสมัครมหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University"
          />
          <meta
            property="og:title"
            content="ขั้นตอนการสมัครของระบบรับสมัครมหาวิทยาลัยราชภัฏกำแพงเพชร"
          />
          <meta property="og:image" content="../../public/favicon.ico" />
        </MetaTags>
        <br />
        <Pane className="container-fluid p-0 m-0 " display="flex" justifyContent="center">
          <Pane boxShadow="0px 0px 16px #00000030" padding={10} borderRadius={10}>
            <div className="text-center">
              {/* <iframe style={{ boxShadow: "1px 1px 2px black, 0 0 25px gray, 0 0 5px darkgray" }} width={this.state.screenWidth} height={this.state.screenHieght * 0.4} src="https://www.youtube.com/embed/ZNJGQTyqqGo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> */}
              <iframe
                style={{
                  height: "100%",
                  width: "clamp(300px,80vw,1080px)",
                  aspectRatio: "4/3",
                }}
                // src="https://www.youtube.com/embed/ji97BK_moiQ?si=EUR20Ic0A4-RskC_?autoplay=1"
                src="https://www.youtube.com/embed/5qsBvWo7i0k?autoplay=1;si=fdiNtZOterdFoHvu&amp;controls=0"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              ></iframe>
            </div>
            {/* <h4 className="card-header bg-primary text-white">ขั้นตอนการสมัคร</h4>
                                        <div style={{fontSize: "16px"}}>
                                            <MDBRow>
                                                <MDBCol className="text-align" lg="3" md="6" sm="12">
                                                    <img src={pic1} width="150" class="img-responsive" alt="Responsive image"/>
                                                    <p><strong>อ่านประกาศรับสมัครสอบ</strong></p>
                                                </MDBCol>
                                                <MDBCol className="text-align" lg="3" md="6" sm="12">
                                                    <img src={pic2} width="150" class="img-responsive" alt="Responsive image"/>
                                                    <p><strong>กรอกข้อมูลใบสมัคร</strong></p>
                                                </MDBCol>
                                                <MDBCol className="text-align" lg="3" md="6" sm="12">
                                                    <a href={`${process.env.REACT_APP_BASENAME || ""}/Checkregister/1`}>
                                                        <img src={pic3} width="150" class="img-responsive" alt="Responsive image"/>
                                                        <p><strong>พิมพ์ใบแจ้งชำระเงิน
                                                            ชำระที่ ธ.กรุงไทย เคาร์เตอร์เซอร์วิส 7-11 หรือเคาร์เตอร์แคลชเชียร์ Big C และตรวจสอบสถานะการสมัครสอบ ภายใน 1-2 วันทำการ</strong></p>
                                                    </a>
                                                </MDBCol>
                                                <MDBCol className="text-align" lg="3" md="6" sm="12">
                                                    <a href={`${process.env.REACT_APP_BASENAME || ""}/Checkregister/2`}>
                                                        <img src={pic4} width="150" class="img-responsive" alt="Responsive image"/>
                                                        <p><strong>พิมพ์ใบสมัคร</strong></p>
                                                    </a>
                                                </MDBCol>
                                            </MDBRow>
                                            </div> */}
            <Pane>
              <Image src={imgKantorn} height="100%" width={"clamp(300px,80vw,1080px)"} />
            </Pane>
          </Pane>
        </Pane>
      </>
    );
  }
}


